<template>
  <div id="bigmap" style="width:80vw; height:80vw;">

  </div>
</template>


<script>
    import * as d3 from "d3";

    export default {
        name: "BigMap",
        data() {
            return {
                dataset: [
                        {
                            "id":"00001",
                            "name":"Bayesian parameter estimation",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00002",
                            "name":"Random variables",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00003",
                            "name":"Bayes' rule",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00004",
                            "name":"Variational mixture of Gaussians",
                            "mastered":false,
                            "value": 10
                        },
                        {
                            "id":"00005",
                            "name":"Bayesian parameter estimation in exponential families",
                            "mastered":false,
                            "value": 10
                        },
                        {
                            "id":"00006",
                            "name":"Bayesian naive Bayes",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00006",
                            "name":"Bayesian naive Bayes",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00006",
                            "name":"Bayesian naive Bayes",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00006",
                            "name":"Bayesian naive Bayes",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00006",
                            "name":"Bayesian naive Bayes",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00006",
                            "name":"Bayesian naive Bayes",
                            "mastered":true,
                            "value": 10
                        },
                        {
                            "id":"00006",
                            "name":"Bayesian naive Bayes",
                            "mastered":true,
                            "value": 10
                        }
                    ]
            };
        },
        mounted(){
            this.initMap();
        },
        methods:{
            initMap(){
                var width = window.innerWidth*0.8
                var height = width

// append the svg object to the body of the page
                var svg = d3.select("#bigmap")
                    .append("svg")
                    .attr("width", width)
                    .attr("height", height)

// Initialize the circle: all located at the center of the svg area
                var node = svg.append("g")
                    .selectAll("g")
                    .data(this.dataset)
                    .enter()
                    .append("g");

                var circle = node
                    .append("circle")
                    .attr("r", 70)
                    .attr("cx", width / 2)
                    .attr("cy", height / 2)
                    .style("fill", "#fff")
                    .attr("stroke", "#DAE6DE")
                    .style("stroke-width", 8);

                  var label = node
                      .append("text")
                      // .attr("x", width/2)
                      // .attr("y", height/2)
                      .text(function(d) { return d.name })
                      .style("fill","#32344F")
                      .style("font","bold 16px sans-serif")
                      .style("text-anchor","middle");

// Features of the forces applied to the nodes:
                var simulation = d3.forceSimulation()
                    .force("center", d3.forceCenter().x(width / 2).y(height / 2)) // Attraction to the center of the svg area
                    .force("charge", d3.forceManyBody().strength(0.5)) // Nodes are attracted one each other of value is > 0
                    .force("collide", d3.forceCollide().strength(.1).radius(90).iterations(2)) // Force that avoids circle overlapping

// Apply these forces to the nodes and update their positions.
// Once the force algorithm is happy with positions ('alpha' value is low enough), simulations will stop.
                simulation
                    .nodes(this.dataset)
                    .on("tick", function(d){
                        circle
                            .attr("cx", function(d){ return d.x; })
                            .attr("cy", function(d){ return d.y; })
                        label
                            .attr("x", function(d){ return d.x; })
                            .attr("y", function(d){ return d.y; })
                    });

            }
        }
    }
</script>


<style scoped>
  #bigmap{
    background-color: #F7F6F3;
    padding:40px;
    border-radius: 50%;
    margin:0 auto;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  label{
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/view/Map/BigMap.vue